import { defineStore } from 'pinia'
import type { Estate, ID } from '@/backend/types'
import { computed, ref } from 'vue'
import type { AvailableProtocolType, AvailableProtocolTypeGroup, OverviewResponse } from '@/backend/types/overview'
import { useLoadingHelper } from '@Visma-Real-Estate-Solutions/acquisit-ui-vue/helpers'
import { useBackend } from '@/backend'
import type { ProtocolTypeResponse } from '@/backend/types/protocol-type'

export const useDataStore = defineStore('data', () => {
	const loading = useLoadingHelper()
	
	// Estates
	const overview = ref<OverviewResponse|null>(null)
	
	const estate = computed((): Estate|null => overview.value?.estate ?? null)
	const availableProtocolGroups = computed((): AvailableProtocolTypeGroup[] => overview.value?.available_protocols ?? [])
	const availableProtocolTypes = computed(() => {
		let types: AvailableProtocolType[] = []
		
		for (let group of availableProtocolGroups.value) {
			types = types.concat(group.types)
		}
		
		return types
	})
	
	const fetchOverview = async (estateID: ID, secret: string, orderID: string | undefined) => {
		loading.set('overview')
		
		try {
			overview.value = await useBackend().getOverview(secret, estateID, orderID)
		} finally {
			loading.done('overview')
		}
	}
	
	// Protocol Types
	const protocolType = ref<ProtocolTypeResponse|null>(null)
	
	const fetchProtocolType = async (estateID: ID, type: string, secret: string) => {
		loading.set('protocolType')
		
        try {
	        protocolType.value = await useBackend().getProtocolType(secret, estateID, type)
        } finally {
            loading.done('protocolType')
        }
	}
	
	return {
		overview,
		estate,
		availableProtocolGroups,
		availableProtocolTypes,
		fetchOverview,
		
		protocolType,
		fetchProtocolType,
		
		isLoading: loading.isSomethingLoading,
		loading,
	}
})
